import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PortalSidebar from '../../admin-shared/PortalSidebar';
import { ENTERPRISE_DEFAULT_ORG_LOGO } from '../../partner/utils/mediaUrl';
import nyafaz from '../../partner/assets/nyafazlogo.png';
import { engagementPath } from '../engagementPaths';
import { getEngagementPortal } from '../engagementPortal';
import { getEngagementSections } from './navConfig';

function badgeSuffix(counts, badgeKey) {
  if (!badgeKey || !(counts[badgeKey] > 0)) return '';
  return ` (${counts[badgeKey]})`;
}

export default function EngagementSidebar({ expanded, setExpanded, counts = {} }) {
  const location = useLocation();
  const navigate = useNavigate();

  const portal = getEngagementPortal();
  const menuItems = useMemo(
    () =>
      getEngagementSections(portal).flatMap((section) =>
        section.items.map((item) => ({
          key: `engagement-${item.segment || 'home'}`,
          to: engagementPath(item.segment),
          label: `${item.label}${badgeSuffix(counts, item.badge)}`,
          sectionId: section.sectionId,
          IconComponent: item.IconComponent,
        })),
      ),
    [counts, portal],
  );

  const [isCompactViewport, setIsCompactViewport] = useState(false);
  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      setIsCompactViewport(w < 1367);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return (
    <PortalSidebar
      menuItems={menuItems}
      logoSrc={nyafaz}
      logoFallback={ENTERPRISE_DEFAULT_ORG_LOGO}
      expanded={expanded}
      setExpanded={setExpanded}
      isCompactViewport={isCompactViewport}
      locationPathname={location.pathname}
      onLogout={() =>
        navigate(portal === 'workspace' ? '/naturals/workspace/overview' : '/naturals/partner/overview')
      }
    />
  );
}
